/**
 * @documental
 * @export Placeholder
 * @name
 * CheckboxGroup.Placeholder
 */
import { FC, ReactElement } from "react";

import { Stack } from "../../layout";

import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { SharedCheckboxPlaceholder } from "../Checkbox/SharedCheckboxPlaceholder";
import { InputContainerPlaceholder } from "../shared/InputContainer/InputContainerPlaceholder";

import styles from "./styles.module.scss";

/**
 * The `Placeholder` component properties.
 */

export interface PlaceholderProps extends BaseProps {
  /**
   * The number of options to show in the placeholder.
   */
  readonly optionCount?: number;
}

/**
 * A loading placeholder for the `CheckboxGroup` component.
 */
export const Placeholder: FC<PlaceholderProps> = (props) => {
  const { optionCount = 2 } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.CheckboxGroupPlaceholder, "checkbox-group", "placeholder"],
    testIdPrefix: "checkbox-group",
  });

  const items: Array<ReactElement> = [];
  for (let i = 0; i < optionCount; i++) {
    items.push(<SharedCheckboxPlaceholder key={i} />);
  }

  return (
    <InputContainerPlaceholder {...getBasePropsFromHtmlProps(baseHtmlProps)}>
      <Stack spacing="none">{items}</Stack>
    </InputContainerPlaceholder>
  );
};
